import React from 'react'

const MobileScreenResetPassword = () => {
    return (
        <div className='bg-[#FFFFFF] px-6 py-10'>
            <img src='/images/tick-mobile-screen.svg' alt='icon' className='mx-auto w-[197px]' />
            <p className='text-sm font-normal text-[#000] mt-2'>Password reset successful<br/>
                kindly login using your mobile application.</p>
        </div>
    )
}

export default MobileScreenResetPassword